export class PillarContent {

  constructor(fields) {
    this.fields = fields;
  }

  mapToStandard() {

    return {
      id: this.fields.attributes.id,
      title: this.fields.attributes.title,
      short_description: this.fields.attributes?.field_short_description?.processed || null,
      full_content: this.fields.attributes?.field_full_content?.value || null,
      has_connectu_page: this.fields.attributes.field_has_connectu_page,
      is_zero_rated: this.fields.attributes.field_is_zero_rated,
      click_out_url: this.fields.attributes.field_click_out_url,
      template: this.getRelationshipValue('node--page_template'),
      image: this.getRelationshipValue('file--file'),
      category: this.getRelationshipValue('taxonomy_term--pillar_type'),
      android_link: this.fields.attributes.field_optional_link_android,
      ios_link: this.fields.attributes.field_optional_link_ios,
      pillar_content_button_text: this.fields.attributes.field_pillar_content_button_text,
      isSubscription: this.fields.attributes.field_is_subscription,
      additionalButtons: this.getRelationshipList('paragraph--button'),
      vodaypayAppId: this.fields.attributes.field_vodapay_app_id,
      hideOnVodapay: !!this.fields.attributes.field_hide_on_vodapay
    };
  }

  getRelationshipValue(type) {

    const rel = this.fields.attributes.relationships.find(
      (i) => i.type === type
    );

    return rel
      ? rel.value
      : null;
  }

  getRelationshipList(type) {

    const rel = this.fields.attributes.relationships.filter(
      (i) => i.type === type
    );

    return rel;
  }
}
